import styled from 'styled-components'

import { ProviderIcon } from '../provider-icon'

import { PROVIDER_PILL_COLORS_MAP } from './constants'

import type { Provider } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type ProviderPillProps = {
  provider: Provider.Provider
  checked: boolean
  onChange?: (checked: boolean, e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
} & ClassNameProps

export const ProviderPill: React.FC<ProviderPillProps> = ({
  provider,
  checked,
  onChange,
  disabled = false,
  className,
}) => {
  const colors = PROVIDER_PILL_COLORS_MAP[provider.internalId]

  return (
    <Root
      type="button"
      role="switch"
      aria-checked={checked}
      aria-pressed={checked}
      aria-label={provider.title}
      data-checked={checked}
      disabled={disabled}
      onClick={(e) => onChange?.(!checked, e)}
      className={className}
      style={
        {
          '--provider-pill-color': colors.text,
          '--provider-pill-bg': colors.bg,
        } as React.CSSProperties
      }
    >
      <ProviderIcon size={18} provider={provider} />
      <Label>{provider.title}</Label>
    </Root>
  )
}

const Root = styled.button`
  appearance: none;
  height: 28px;
  padding-inline: 8px;
  background: transparent;

  border-radius: 6px;
  border: 1px solid var(--background-4);

  display: inline-flex;
  align-items: center;
  gap: 4px;

  cursor: pointer;
  user-select: none;
  transition:
    background-color 0.15s linear,
    border-color 0.15s linear,
    color 0.15s linear;

  color: var(--text-11);

  &:hover {
    background: var(--backgroundA-2);
    border-color: var(--background-5);
  }

  &[data-checked='true'] {
    color: var(--provider-pill-color);
    border-color: transparent;
    background: var(--provider-pill-bg);
    &:hover {
      border-color: var(--backgroundA-3);
    }
  }
`

const Label = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: inherit;
`
